import { useLocation } from 'react-router-dom';
import JsonLd from '@/components/base/JsonLd';

export default function PageSEO() {
  const location = useLocation();

  const getTitle = () => {
    if (location.pathname === '/') return '91传媒官方落地页 | 91传媒平台介绍与服务';
    if (location.pathname.startsWith('/category/')) return '分类浏览 | 91传媒';
    if (location.pathname.startsWith('/article/')) return '文章详情 | 91传媒';
    if (location.pathname === '/about') return '关于我们 | 91传媒';
    return '91传媒';
  };

  const getDescription = () => {
    if (location.pathname === '/') return '91传媒是专注于数字内容传播与媒体服务的综合平台。';
    if (location.pathname.startsWith('/category/')) return '浏览91传媒分类文章，探索数字传媒领域的深度内容。';
    if (location.pathname.startsWith('/article/')) return '阅读91传媒精选文章，获取行业前沿洞察。';
    if (location.pathname === '/about') return '了解91传媒品牌故事、发展历程与合作方式。';
    return '91传媒 - 数字内容传播与媒体服务平台';
  };

  const getCanonical = () => {
    return `https://www.91media.com${location.pathname}`;
  };

  const getStructuredData = () => {
    const baseWebSite = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '91传媒',
      url: 'https://www.91media.com/',
      description: '91传媒是专注于数字内容传播与媒体服务的综合平台。',
    };

    const baseBreadcrumb = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.91media.com/',
        },
      ],
    };

    if (location.pathname.startsWith('/category/')) {
      return [baseWebSite, baseBreadcrumb];
    }

    if (location.pathname.startsWith('/article/')) {
      return [
        baseWebSite,
        {
          ...baseBreadcrumb,
          itemListElement: [
            ...baseBreadcrumb.itemListElement,
            {
              '@type': 'ListItem',
              position: 2,
              name: '文章详情',
              item: `https://www.91media.com${location.pathname}`,
            },
          ],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: '文章详情',
          url: `https://www.91media.com${location.pathname}`,
        },
      ];
    }

    return [baseWebSite, baseBreadcrumb];
  };

  const structuredData = getStructuredData();

  return (
    <>
      <title>{getTitle()}</title>
      <meta name="description" content={getDescription()} />
      <link rel="canonical" href={getCanonical()} />
      <meta property="og:title" content={getTitle()} />
      <meta property="og:description" content={getDescription()} />
      <meta property="og:url" content={getCanonical()} />
      <meta name="twitter:title" content={getTitle()} />
      <meta name="twitter:description" content={getDescription()} />
      {Array.isArray(structuredData)
        ? structuredData.map((data, i) => <JsonLd key={i} data={data} />)
        : <JsonLd data={structuredData} />}
    </>
  );
}